<template>
  <el-dialog :title="title" :visible.sync="addExpressVisible" :close-on-click-modal="false"
             :close-on-press-escape="false" width="500px">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="90px">
      <el-form-item label="发货日期:" prop="expressDate">
        <el-date-picker v-model="data.expressDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"
                        style="width:100%"></el-date-picker>
      </el-form-item>
      <el-form-item label="收货人:" prop="receiverName">
        <el-input v-model="data.receiverName" :maxlength="100" placeholder="请输入" clearable/>
      </el-form-item>
      <el-form-item label="联系电话:" prop="receiverMobile">
        <el-input v-model="data.receiverMobile" :maxlength="100" placeholder="请输入" clearable/>
      </el-form-item>
      <el-form-item label="物流公司:" prop="logisticsCompanyCode">
        <el-select ref='logisticsRef' v-model="data.logisticsCompanyCode" placeholder="请选择" clearable
                   style="width:100%">
          <el-option v-for="dict in logisticsCompanyList" :key="dict.code" :label="dict.name" :value="dict.code"/>
        </el-select>
      </el-form-item>
      <el-form-item label="物流单号:" prop="logisticsNum">
        <el-input v-model="data.logisticsNum" :maxlength="100" placeholder="请输入" clearable/>
      </el-form-item>
      <el-form-item label="物流费用:" prop="logisticsFee">
        <el-input-number v-model="data.logisticsFee" :precision="2" :min="0" placeholder="请输入"
                         clearable></el-input-number>
        元
      </el-form-item>
      <el-form-item label="备注:" prop="expressRemark">
        <el-input v-model="data.expressRemark" type="textarea" :maxlength="1000" placeholder="请输入" clearable/>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="addExpressVisible = false">取消</el-button>
      <el-button type="primary" @click="confirmAdd">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {express, editExpress, logisticsCompanyList} from "@/api/crm/order";
import {mapState} from 'vuex'

export default {
  name: "addExpressDialog",
  props: {},
  data() {
    return {
      title: '',
      deliveryOrderId: null,
      editFlag: false,
      addExpressVisible: false,
      logisticsCompanyList: [], // 物流公司
      rules: {
        expressDate: [
          {required: true, message: '请选择发货日期', trigger: 'change'}
        ],
        receiverName: [
          {required: true, message: '请填写收货人', trigger: 'change'}
        ],
        receiverMobile: [
          {required: true, message: '请填写联系电话', trigger: 'change'}
        ],
        logisticsFee: [
          {required: true, message: '请输入物流费用', trigger: 'change'}
        ],
      },
      data: {
        deliveryOrderId: null,
        expressDate: '',
        receiverName: '',
        receiverMobile: '',
        logisticsNum: '',
        logisticsCompanyCode: '',
        logisticsCompanyName: '',
        logisticsFee: 0,
        expressRemark: ''
      }
    };
  },
  created() {
    this.queryLogisticsCompanyList()
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  watch: {
    visible(val) {
      if (!val) {
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    open(deliverId, row) {
      if (row) {
        this.title = '编辑发货信息'
        this.editFlag = true
        this.data = JSON.parse(JSON.stringify(row))
      } else {
        this.title = '添加发货信息'
        this.editFlag = false
        this.data = {
          deliveryOrderId: deliverId,
          logisticsFee: 0
        }
        this.resetForm("addForm");
      }
      this.addExpressVisible = true
    },
    // 查询物流公司
    queryLogisticsCompanyList() {
      logisticsCompanyList().then(response => {
        this.logisticsCompanyList = response.data
      }).catch(error => {
      })
    },
    // 确认添加单条发货信息
    confirmAdd() {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
          if (this.editFlag) {
            editExpress(this.data).then(response => {
              this.$emit('success')
              this.addExpressVisible = false
              this.msgSuccess("操作成功");
            }).finally(() => {
              loading.close()
            })
          } else {
            express(this.data).then(response => {
              this.$emit('success')
              this.addExpressVisible = false
              this.msgSuccess("操作成功");
            }).finally(() => {
              loading.close()
            })
          }
        }
      });
    }
  }
};
</script>
